import clsx from 'clsx'
import {KTSVG} from '../../../../../_gori/helpers'
import {useChatbotContext} from '../../context'
import {MESSAGE_ACTION, MessageContent, MessageItemCommonProps} from '../../definitions'
import ChatbotService from '../../services/request'

type MessageReactionProps = {
  path: string
  active?: boolean
  onClick?: () => void
}

type MessageReactionsProps = MessageItemCommonProps<MessageContent>

export const MessageReaction = ({path, active = false, onClick}: MessageReactionProps) => {
  return (
    <div
      className={clsx(
        'chatbot-icon cursor-pointer w-25px h-25px d-flex justify-content-center align-items-center bg-hover-light rounded-4',
        {
          'bg-primary chatbot-icon__active': active,
        }
      )}
      onClick={onClick}
    >
      <KTSVG path={path} className='svg-icon svg-icon-3' />
    </div>
  )
}

export const MessageReactions = ({className, message}: MessageReactionsProps) => {
  const {patchMessage} = useChatbotContext()

  const onClickReaction = async (liked: boolean) => {
    const newAction =
      liked && message?.action === MESSAGE_ACTION.LIKE
        ? null
        : liked
        ? MESSAGE_ACTION.LIKE
        : MESSAGE_ACTION.DISLIKE
    patchMessage(message.id, {
      action: newAction,
    })
    await ChatbotService.updateAction(message.id, newAction)
  }

  return (
    <div className={clsx('d-flex gap-2', className)}>
      <MessageReaction
        active={message.action === MESSAGE_ACTION.LIKE}
        path={'/media/gori/chatbot/like.svg'}
        onClick={() => onClickReaction(true)}
      />
      <MessageReaction
        active={message.action === MESSAGE_ACTION.DISLIKE}
        path={'/media/gori/chatbot/unlike.svg'}
        onClick={() => onClickReaction(false)}
      />
    </div>
  )
}
